<template>
  <container :class="['bcq-bundler']">
    <card>
      <card-title bg-color="transparent" :bg-color-lightness="null">
        <toolbar dense bg-color="transparent" :bg-color-lightness="null">
          <toolbar-icon>
            <icon name="package-variant" :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" />
          </toolbar-icon>
          <toolbar-actions width="80%">
            <btn @click="createBundle" size="sm" color="white" :color-lightness="null" :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness" :title="$lang.createBundle">{{ $lang.createBundle }}</btn>
          </toolbar-actions>
        </toolbar>
      </card-title>
      <card-text>
        <container :class="['pb-4']">
          <text-field clearable :color="$root.$colors.primary" :color-lightness="$root.$colors.bgColorLightness" v-model="search" icon-left="magnify" :placeholder="$lang.searchComponent" />
        </container>
        <list>
          <list-item :title="$lang.addRemoveFromBundle(component.selected)" @click="component.selected = !component.selected" v-for="(component, index) in filteredComponents" :key="index" :disabled="component.disabled">
            <list-item-icon>
              <checkbox :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="component.selected" />
            </list-item-icon>
            <list-item-content>
              <list-item-content-title v-html="component.value" />
              <list-item-content-sub-title :truncate="false" v-html="$lang.bundleDependencies(component.dependencies)" />
            </list-item-content>
            <list-item-avatar width="48px">
              <avatar size="36px" :tag="component.path ? 'router-link' : 'span' " :to="component.path" :bg-color="$root.colors.primary" :color-lightness="null" color="white" :bg-color-lightness="$root.colors.bgColorLightness" :icon="avatarIcon(component)" :text="avatarText(component)" />
            </list-item-avatar>
          </list-item>
        </list>
      </card-text>
    </card>
    <dialog-box :title-divider="false" max-width="80%" @dismiss="close" icon="package-variant" v-model="dialog" :class="['code-viewer', 'code-viewer-bundle']" :title="$lang.customBuildBundler" modal persistent title-color="white" :title-color-lightness="null" :title-bg-color="$root.$colors.primary" :title-bg-color-lightness="$root.$colors.bgColorLightness">
      <template v-slot:content>
        <toolbar bg-color="gray" :bg-color-lightness="800">
          <toolbar-actions width="100%">
            <btn :class="['mr-2']" tag="a" :href="`${$root.config.staticAssetsDir}/downloads/bcq-ui-${$config.version}.zip`" icon-left="download" size="sm" color="white" :title="$lang.downloadBcqUi" :color-lightness="null" :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.bcqUi }}</btn><!--
            --><btn @click="download" icon-left="download" size="sm" color="white" :title="$lang.downloadBundle" :color-lightness="null" :bg-color="$root.$colors.primary" :bg-color-lightness="$root.$colors.bgColorLightness">{{ $lang.bundle }}</btn>
          </toolbar-actions>
        </toolbar>
        <divider />
        <div :class="['overflow-auto', 'code-viewer-bundle-wrapper']">
          <vue-code-highlight language="js">{{ code }}</vue-code-highlight>
        </div>
      </template>
    </dialog-box>
  </container>
</template>
<script>
import bundler from '../helpers/bundler'
import methods from '../mixins/methods'
import FileSaver from 'file-saver'
import { component as VueCodeHighlight } from 'vue-code-highlight'

export default {
  name: 'BcqBundler',
  components: {
    VueCodeHighlight
  },
  mixins: [
    methods
  ],
  data () {
    return {
      components: [],
      dialog: false,
      fileName: 'index.js',
      code: null,
      search: ''
    }
  },
  computed: {
    filteredComponents () {
      return this.components.filter(item => {
        return item.value.toLowerCase().indexOf(this.search.toLowerCase()) > -1
      })
    }
  },
  mounted () {
    this.prepareData()
  },
  methods: {
    avatarIcon (component) {
      return component.icon ? component.icon : null
    },
    avatarText (component) {
      return !component.icon ? component.value.substring(0, 2).toUpperCase() : null
    },
    prepareData () {
      const components = []
      bundler.forEach(component => {
        const value = component.value
        const route = this.$router.options.routes.find(route => route.path.split('/')[2] === value || '')
        let subdeps = []
        component.dependencies.forEach(dependency => {
          const dep = bundler.find(d => d.value === dependency)
          subdeps = subdeps.concat(dep ? dep.dependencies : [])
        })
        component.icon = route ? route.icon : null
        component.path = route ? route.path : null
        component.selected = component.selected || false
        component.disabled = component.disabled || false
        component.dependencies = component.dependencies.concat(subdeps)
        component.dependencies.unshift(value)
        component.dependencies.sort()
        component.dependencies = Array.from(new Set(component.dependencies))
        components.push(component)
      })
      this.components = components
    },
    createImport (component) {
      const name = this.kebabToCamelCase(component, true)
      return `export { default as ${name} } from './${component}'`
    },
    download () {
      const file = new File([this.code], this.fileName, {
        type: 'text/plain;charset=utf-8'
      })
      FileSaver.saveAs(file)
    },
    close () {
      this.dialog = false
      this.code = null
    },
    createBundle () {
      let components = []
      let code = []
      const entry = 'bcq-ui'
      this.components.forEach(component => {
        if (component.selected) {
          components = components.concat(component.dependencies)
        }
      })
      components = Array.from(new Set(components))
      components.sort()
      components.forEach(component => {
        if (component !== entry) {
          code.push(this.createImport(component))
        }
      })
      code.unshift(this.$lang.bundleCodeComments, this.createImport(entry), '')
      code.push('')
      code = code.join('\n')
      this.code = code
      this.dialog = true
    }
  }
}
</script>
<style>
.code-viewer-bundle .bcq-card-text
{
  padding: 0;
}

.code-viewer-bundle .code-viewer-bundle-wrapper
{
  height: 70vh;
}
</style>



// WEBPACK FOOTER //
// src/components/bcq-bundler.vue